import React from 'react';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';

import { Genre } from 'types';
import Button from 'components/button';
import './styles.scss';

interface IGenresFilter {
  selected?: Genre;
  onClick: (selected?: Genre) => void;
}

const GenresFilter: React.FC<IGenresFilter> = ({ selected, onClick}) => {
  const { t } = useTranslation();

  return (
    <div className="genres-filter-container flex flex-wrap p-side mb2">
      <Button
        title={t('allGenres')}
        className={!selected ? 'filled' : ''}
        onClick={() => onClick(undefined)}
      />
      {Object.values(Genre).map((genre) => (
        <Button
          key={genre}
          title={t(`genre${upperFirst(genre)}`)}
          className={genre === selected ? 'filled' : ''}
          onClick={() => onClick(genre)}
        />
      ))}
    </div>
  );
};

export default GenresFilter;
